// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__rrKvi","span":"Profile_span__YN10j","verified":"Profile_verified__kd1Ch"};